import React from 'react';
import './About.css';

function About() {
  return (
    <section className="about-section">
      <div className="about-container">
        <h2 className="about-heading">RyzenSports</h2>
        <p className="about-text">
          Embark on an exhilarating journey through the world of sports with Ryzen. From the thrill of victory to the spirit of teamwork, we celebrate every moment that defines athletic excellence. </p>
      </div>
    </section>
  );
}

export default About;
